module.exports = __webpack_public_path__ + "img/logo-UMC-tmp.13e36f4c.svg";